<template>
  <div class="fixedPriceAboutContainer w-100">
    <MarketingRow
      :backgroundColor="fixedPriceAboutContent.backgroundColor"
      :body="fixedPriceAboutContent.body"
      :noAssetBackground="fixedPriceAboutContent.noAssetBackground"
      :textSide="fixedPriceAboutContent.textSide"
      :title="fixedPriceAboutContent.title"
      :titleType="fixedPriceAboutContent.titleType"
    >
      <template v-slot:marketingContent>
        <BImgLazy
          :alt="fixedPriceAboutContent.title.join(' ')"
          :class="{ overflowImage: fixedPriceAboutContent.overflowImage, 'contain': fixedPriceAboutContent.containImage }"
          :src="!isMobile ? fixedPriceAboutContent.imageUrlDesktop : fixedPriceAboutContent.imageUrlMobile"
        />
      </template>
    </MarketingRow>
    <VerticalIconMessage :messages="fixedPriceTripleIconMessages" />
    <MarketplaceDescription
      :body="fixedDescription.body"
      :darkButtonLink="fixedDescription.darkButtonLink"
      :darkButtonText="fixedDescription.darkButtonText"
      :defaultButtonLink="fixedDescription.defaultButtonLink"
      :defaultButtonText="fixedDescription.defaultButtonText"
      :desktopImage="fixedDescription.desktopImage"
      :mobileImage="fixedDescription.mobileImage"
      :title="fixedDescription.title"
    />
    <div class="bg-gradient-light-gray py-3">
      <MarketingRow
        :backgroundColor="ourRates.backgroundColor"
        :body="ourRates.body"
        :noAssetBackground="ourRates.noAssetBackground"
        :textSide="ourRates.textSide"
        :title="ourRates.title"
        :titleType="ourRates.titleType"
      >
        <template v-slot:marketingContent>
          <BImgLazy
            :alt="ourRates.title.join(' ')"
            :class="{ overflowImage: ourRates.overflowImage, 'contain': ourRates.containImage }"
            :src="!isMobile ? ourRates.imageUrlDesktop : ourRates.imageUrlMobile"
          />
        </template>
      </MarketingRow>
      <PricesGridRow
        :backgroundColor="fixedPriceFees.backgroundColor"
        :bodyText="fixedPriceFees.bodyText"
        :hasBorderTop="fixedPriceFees.hasBorderTop"
        :priceSections="fixedPriceFees.priceSections"
        :showSubmitButton="fixedPriceFees.showSubmitButton"
        :smallTitle="fixedPriceFees.smallTitle"
        :title="fixedPriceFees.title"
      />
    </div>
  </div>
</template>
<script>
import { BImgLazy } from 'bootstrap-vue';
import PricesGridRow from './PricesGridRow.vue';
import MarketplaceDescription from './MarketplaceDescription.vue';
import VerticalIconMessage from './VerticalIconMessage.vue';
import MarketingRow from '../../homepage/components/MarketingRow.vue';
import { fixedPriceAboutContent, fixedDescription, fixedPriceFees, fixedPriceTripleIconMessages } from '../constants/fixedPriceConstants';
import { ourRates } from '../constants/singleMarketplaceConstants';
import { baseIsMobile } from '../../marketplaces/mixins';

export default {
  name: 'FixedPriceAbout',
  components: {
    BImgLazy,
    MarketingRow,
    MarketplaceDescription,
    PricesGridRow,
    VerticalIconMessage
  },
  mixins: [baseIsMobile],
  data() {
    return {
      fixedPriceAboutContent,
      fixedDescription,
      fixedPriceFees,
      fixedPriceTripleIconMessages,
      ourRates
    };
  }
};
</script>
